export default "__VITE_ASSET__Bv7N3gOA__"